import get from 'lodash/get'
import has from 'lodash/has'
import isNil from 'lodash/isNil'

import * as PoziUtils from 'api/utils'
import PoziJotForm from 'data/jotform'

// import PoziFragments from 'drawer/tabs/info/fragment/fragments'

function PoziJotFormLikes () {
  // Adapters
  const adapters = {
    /**
     * @api {NA} PoziJotFormLikes().load Load JotForm Likes
     * @apiDescription Load JotForm likes and render on the info tab.
     * @apiGroup Fragments
     * @apiName JotFormLikes
     *
     * @apiParam {Object} fragmentOptions Fragment and Layer
     * @apiParam {Object} fragmentOptions.fragment Fragment
     * @apiParam {Object} fragmentOptions.fragment.id Fragment ID
     * @apiParam {Object} fragmentOptions.layer Layer
     *
     * @apiSuccess {Promise} Resolve No errors
     * @apiError {Promise} Reject Error to console
     */
    load: function (fragmentOptions) {
      return load(fragmentOptions)
    }
  }

  var load = function (fragmentOptions) {
    return check(fragmentOptions)
      .then(getData)
      .then(render)
      .then(success)
      .catch(error)
  }

  var getData = function (fragmentOptions) {
    return new Promise(function (resolve, reject) {
      const fragment = fragmentOptions.fragment
      fragment.url = fragment.url.replace('[timestampToNearestOneMin]', PoziUtils.timestampRoundedUpToMinutes(2))
      const bUseText = false // Uses label instead as property
      PoziJotForm()
        .getGeoJSON(fragment.url, bUseText)
        .then(function (geoJSON) {
          fragment.geoJSON = geoJSON
          resolve(fragmentOptions)
        })
        .catch(reject)
    })
  }

  var render = function (fragmentOptions) {
    return new Promise(function (resolve, reject) {
      let err = ''
      console.log('Render JotForm likes', fragmentOptions)

      const fragment = fragmentOptions.fragment
      const featureidSelected = get(fragmentOptions, 'loadOptions.featureid', null)
      if (isNil(featureidSelected)) {
        err = 'Unable to find a featureid to compare.'
        return reject(err)
      }
      const geoJSON = get(fragment, 'geoJSON', null)
      if (isNil(geoJSON)) {
        err = 'Unable to render geojson'
        return reject(err)
      }

      const features = get(geoJSON, 'features', [])
      fragment.likeCount = 0
      fragment.commentCount = 0
      for (const key in features) {
        const feature = features[key]
        const comment = get(feature, 'properties.comment', '')
        const featureidComment = get(feature, 'properties.featureId', null)
        if (isNil(featureidComment)) {
          continue
        }
        if (featureidSelected === featureidComment) {
          if (comment !== '') {
            fragment.commentCount++
          }
          if (has(feature, 'properties.like')) {
            fragment.likeCount++
          }
        }
      }

      /* var id = 'jotformlikes-' + fragment.id
      var html = $('<div>')
        .attr('id', id)
        .append('<img class="fragment_jotform_stats_heart" src="img/font-awesome/misc/heart-salmon.svg">')
        .append('&nbsp;&nbsp;' + fragment.likeCount + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        .append('<img class="fragment_jotform_stats_comment" src="img/font-awesome/misc/comment-gray.svg">')
        .append('&nbsp;&nbsp' + fragment.commentCount)

        var wrapper = PoziFragments().getWrapper(fragment)
      wrapper.append('<hr/>')
      wrapper.append(html)
      */

      return resolve(fragmentOptions)
    })
  }

  var check = function (fragmentOptions) {
    return new Promise(function (resolve, reject) {
      let err = ''

      if (isNil(fragmentOptions)) {
        err = 'Invalid fragmentOptions object.'
        return reject(err)
      }

      if (!has(fragmentOptions, 'loadOptions')) {
        err = 'No loadOptions object.'
        return reject(err)
      }

      if (!has(fragmentOptions, 'fragment')) {
        err = 'No fragment object.'
        return reject(err)
      }

      const loadOptions = fragmentOptions.loadOptions

      if (isNil(loadOptions)) {
        err = 'Invalid loadOptions object.'
        return reject(err)
      }

      if (!has(loadOptions, 'layer')) {
        err = 'Must include loadOptions.layer.'
        return reject(err)
      }

      if (!has(loadOptions, 'titleid')) {
        err = 'Must include loadOptions.titleid.'
        return reject(err)
      }

      if (!has(loadOptions, 'featureid')) {
        err = 'Warning: does not include a loadOptions.featureid.'
        console.log(err)
      }

      const fragment = fragmentOptions.fragment

      if (get(fragment, 'url', '') === '') {
        err = 'No fragment URL found.'
        return reject(err)
      }

      return resolve(fragmentOptions)
    })
  }

  var success = function (fragmentOptions) {
    console.log('PoziJotFormLikes load success.')
    return fragmentOptions
  }

  var error = function (err) {
    console.log('PoziJotFormLikes load failed.', err)
    throw err
  }

  // Return adapters (must be at end of adapter)
  return adapters
}

export default PoziJotFormLikes
// End A (Adapter)
